/**
 * Copyright (c) 2025 eBUCIS, LLC. All rights reserved.
 *
 * Vocab Service - API client for Vocab Word of the Day and Math Term Matching
 *
 * This software is proprietary and confidential. Unauthorized copying,
 * distribution, or modification is strictly prohibited.
 */

import api from './api'

const vocabService = {
  async getWordOfTheDay() {
    const response = await api.get('/vocab/word-of-the-day')
    return response.data
  },

  async recordInteraction(vocabWordId, response) {
    const res = await api.post('/vocab/interaction', { vocabWordId, response })
    return res.data
  },

  async getRecentWords() {
    const response = await api.get('/vocab/recent')
    return response.data
  },

  async getMathTerms(count = 6, subject = null, excludeIds = []) {
    const params = new URLSearchParams({ count })
    if (subject) params.set('subject', subject)
    if (excludeIds.length > 0) params.set('exclude', excludeIds.join(','))
    const response = await api.get(`/vocab/math-terms?${params}`)
    return response.data
  }
}

export default vocabService
